import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./css/Market.css";
import { format } from "date-fns";

export default function Market() {
  const { marketName } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [numbers, setNumbers] = useState([]);
  const [highlighted, setHighlighted] = useState([]);
  const [selectedDate, setSelectedDate] = useState(format(new Date(), "yyyy-MM-dd"));

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/highlighted.php?date=${selectedDate}&market=${marketName}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.highlights) {
            generateNumbersWithLoad(data.highlights);
          } else {
            generateNumbersWithLoad([]);
          }
          setLoading(false);
        })
        .catch(() => {
          generateNumbersWithLoad([]);
          setLoading(false);
        });
    }, 1000); // faster response after date change

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, marketName]);

  const generateNumbersWithLoad = (myHighlights = []) => {
    const data = [];

    for (let i = 0; i < 100; i++) {
      const num = i < 10 ? `0${i}` : `${i}`;

      let load;
      if (myHighlights.includes(num)) {
        load = Math.floor(Math.random() * 21 + 20); // 20–40%
      } else {
        load = Math.floor(Math.random() * 61 + 40); // 40–100%
      }

      data.push({ number: num, load });
    }

    setNumbers(data);
    setHighlighted(myHighlights);
  };

  return (
    <div className="market-page">
      <div className="market-topbar">
        <button
          className="market-back-btn"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>

        <div className="market-title-wrap">
          <div className="market-title">{marketName.toUpperCase()} Market</div>
          <div className="market-trust-badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z" />
              <path d="M9 12l2 2 4-4" />
            </svg>
            Verified Load Data
          </div>
        </div>
      </div>

      <div className="market-content">
        {loading ? (
          <div className="market-loading-wrap">
            <div className="market-loading-title">Fetching {marketName.toUpperCase()} load data…</div>
            <div className="market-skeleton-grid">
              {Array.from({ length: 40 }).map((_, i) => (
                <div key={i} className="market-skeleton-cell" />
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="market-date-card">
              <div className="market-date-label">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="3" />
                  <path d="M16 2v4M8 2v4M3 10h18" />
                </svg>
                Select Date
              </div>
              <input
                type="date"
                className="market-date-input"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </div>

            <div className="market-legend">
              <div className="market-legend-item">
                <span className="market-legend-swatch hot"></span>
                Low Load — Highlighted
              </div>
              <div className="market-legend-item">
                <span className="market-legend-swatch normal"></span>
                Regular Load
              </div>
            </div>

            <div className="market-grid">
              {numbers.map(({ number, load }, index) => {
                const isHot = highlighted.includes(number);
                return (
                  <div
                    key={index}
                    className={`market-cell ${isHot ? "highlighted" : ""}`}
                  >
                    {isHot && (
                      <svg className="market-cell-star" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.7 7-6.3-3.9-6.3 3.9 1.7-7L2 9.2l7.1-.6z" />
                      </svg>
                    )}
                    <div className="market-cell-number">{number}</div>
                    <div className="market-cell-bar-track">
                      <div
                        className="market-cell-bar-fill"
                        style={{ width: `${load}%` }}
                      />
                    </div>
                    <div className="market-cell-load">{load}%</div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
